export let user=(valor)=>{ return {type:"USER",payload:valor} };
export let userLogin=(valor)=>{ return {type:"LOGIN",payload:valor} };

